import { AndroidContent } from "@/models/androidcontent";
import { IosContent } from "@/models/ioscontent";
import { ModelValidation } from "@/models/modelvalidation";

export interface IAsset {
    uuid?: string | null;
    name?: string | null;
    description?: string | null;
    status?: string | null;
    ios?: IosContent;
    android?: AndroidContent;
    override?: boolean | false;
}

export class Asset extends ModelValidation {
    public uuid!: string | null;
    public name!: string | null;
    public description!: string | null;
    public status!: string | null;
    public ios!: IosContent;
    public android!: AndroidContent;
    public override! : boolean | false;

    constructor(asset: IAsset) {
        super();

        if (!asset) {
            throw new Error("Cannot construct Asset from falsey IAsset");
        }

        this.uuid = asset.uuid || null;
        this.name = asset.name || null;
        this.description = asset.description || null;
        this.status = asset.status || "";
        this.ios = asset.ios || IosContent.empty();
        this.android = asset.android || AndroidContent.empty();
        this.override = asset.override || false;
    }

    public static empty(): Asset {
        return new Asset({});
    }

    public toNewAssetDto(): IAsset {
        return {
            name: this.name,
            description: this.description
        };
    }
    public toUpdateAssetDto(): IAsset {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewAssetDto();
        result.uuid = this.uuid;
        result.status = this.status;
        return result;
    }
}
